export const SCHEMA_DEFAULT_LDJSON = {
    "@context": "http://schema.org",
    "@type": "WebSite",
    "name": "Scuola di Formazione Ipsoa",
    "url": "https://formazione.ipsoa.it",
    "potentialAction": {
        "@type": "SearchAction",
        "target": "https://formazione.ipsoa.it/formazione?query={search_term_string}",
        "query-input": "required name=search_term_string"
    }
};
